import { CreateProductCategory, ProductCategory, UpdateProductCategory } from "../../Models/ProductCategory";
import api from "../axios";

export const productCategoryService = {
  get: async (id: string): Promise<ProductCategory> => {
    const response = await api.get(`/product-category/${id}`);
    return response.data;
  },

  getAll: async (): Promise<ProductCategory[]> => {
    const response = await api.get('/product-category');
    return response.data;
  },

  create: async (data: CreateProductCategory) => {
    const response = await api.post('/product-category', data);
    return response.data;
  },

  update: async (data: UpdateProductCategory) => {
    const response = await api.put('/product-category', data);
    return response.data;
  },

  delete: async (id: string) => {
    const response = await api.delete(`/product-category/${id}`);
    return response.data;
  }
};
